import { jsx } from "react/jsx-runtime";
import classnames from "classnames";
import AvatarContainer from "./AvatarContainer.js";
import { rootClass } from "../constant.js";
import { ImageLoadFailOutlined } from "@wepie/weet-icons";
function ErrorAvatar(props) {
    return /*#__PURE__*/ jsx(AvatarContainer, {
        ...props,
        className: classnames(props.className, `${rootClass}__error`),
        children: /*#__PURE__*/ jsx("span", {
            className: "weet-avatar-icon",
            children: /*#__PURE__*/ jsx(ImageLoadFailOutlined, {})
        })
    });
}
export { ErrorAvatar as default };
